import { FC } from 'react'
import styled, { useTheme } from 'styled-components'
import { Text } from '@/components/common'
import { LinkButton } from '@/components/common/buttons'
import { FontWeightEnum } from '@/constants/font-weight.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { LocationEnum } from '@/constants/location.enum'
import { useCustomRouter } from '@/containers/hooks'

type RootCategoryTabProps = {
  tabTitle: string
  categoryId?: string
  isActive: boolean
}

const RootCategoryTab: FC<RootCategoryTabProps> = ({ tabTitle, categoryId, isActive }) => {
  const { color } = useTheme()
  const { query } = useCustomRouter()
  const { brandId, orderBy } = query

  const createRipple = (event: any) => {
    const buttonElement = event.currentTarget
    let ripple = document.createElement('span')
    const size = buttonElement.offsetWidth
    const pos = buttonElement.getBoundingClientRect()

    ripple.style.width = ripple.style.height = `${size}px`
    ripple.style.left = `${event.clientX - pos.x - size / 2}px`
    ripple.style.top = `${event.clientY - pos.y - size / 2}px`
    ripple.classList.add('ripple')

    if (ripple) {
      ripple.remove()
    }
    buttonElement.appendChild(ripple)
  }

  return (
    <LinkButton
      url={{
        pathname: ROUTES.BRAND_DETAIL,
        query: {
          brandId: brandId,
          rootCategoryId: categoryId,
          location: LocationEnum.Category,
          orderBy,
        },
      }}
      routeType="replace"
      shallow
    >
      <StyledRootCategoryTab
        isActive={isActive}
        onClick={(e) => {
          if (isActive) {
            return
          }
          createRipple(e)
        }}
      >
        <Text.Body1
          fontWeight={isActive ? FontWeightEnum.Bold : FontWeightEnum.Medium}
          fontColor={isActive ? color.gray900 : color.gray300}
        >
          {tabTitle}
        </Text.Body1>
      </StyledRootCategoryTab>
    </LinkButton>
  )
}

const StyledRootCategoryTab = styled.div<{ isActive: boolean }>`
  padding: ${({ theme: { spacing } }) => spacing.size12} ${({ theme: { spacing } }) => spacing.size12}
    ${({ theme: { spacing } }) => spacing.size14} ${({ theme: { spacing } }) => spacing.size12};
  position: relative;
  overflow: hidden;
  cursor: pointer;

  ::after {
    z-index: 2;
    content: '';
    position: absolute;
    visibility: ${({ isActive }) => (isActive ? 'visible' : 'hidden')};
    bottom: 0;
    left: 0;
    width: ${({ theme: { spacing } }) => spacing.per100};
    height: ${({ theme: { spacing } }) => spacing.size2};
    background-color: ${({ theme: { color } }) => color.gray900};
  }
`

export default RootCategoryTab
